export default __webpack_public_path__ + "static/media/info.9322305b.svg";